export default __webpack_public_path__ + "static/media/cross.61416a05.svg";